<div class="data-table-demo-page">
  <div class="top-header">
    <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-plain back-button"
      routerLink="/admin">
    </button>
    <h1 class="page-title">{{ 'Data Table Component Demo' | translate }}</h1>
   
  </div>

  <div class="page-content">
    <div class="table-container">
      <app-data-table
        [columns]="tableColumns"
        [data]="users"
        [config]="tableConfig"
        [totalRecords]="totalRecords"
        [loading]="loading"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)"
        (onPage)="onPageChange($event)"
        (onSort)="onSort($event)"
        (onFilter)="onFilter($event)"
        (onSelectAllChange)="onSelectAllChange($event)">
      </app-data-table>
    </div>
    
    <div class="checkbox-demo-section">
      <h2 class="section-title">{{ 'Checkbox Component Demo' | translate }}</h2>
      
      <div class="checkbox-examples">
        <app-checkbox 
          [(ngModel)]="checkboxStates.demo" 
          label="Custom checkbox component">
        </app-checkbox>
      </div>
    </div>
    
    <div class="button-demo-section">
      <h2 class="section-title">{{ 'Button Component Demo' | translate }}</h2>
      
      <div class="button-examples">
        <app-button variant="primary" (onClick)="onButtonClick('Without Icon')">{{ 'Button Without Icon' | translate }}</app-button>
        <app-button 
          variant="primary" 
          iconPath="plus"
          (onClick)="onButtonClick('With Icon')">
          {{ 'Button With Icon' | translate }}
        </app-button>
      </div>
    </div>
    
    <div class="input-demo-section">
      <h2 class="section-title">{{ 'Input Component Demo' | translate }}</h2>
      
      <div class="input-examples">
        <app-input 
          [(ngModel)]="inputValue" 
          placeholder="Enter text here"
          label="Input Field">
        </app-input>
      </div>
    </div>
    
    <div class="theme-toggle-demo-section">
      <h2 class="section-title">{{ 'Theme Toggle Component Demo' | translate }}</h2>
      
      <div class="theme-toggle-examples">
        <button
          class="theme-button"
          (click)="toggleTheme()">
          <img
            [src]="getIconPath('color-mode')"
            [alt]="themeService.isDarkMode() ? ('Light Mode' | translate) : ('Dark Mode' | translate)"
            width="24"
            height="24"/>
        </button>
      </div>
    </div>
    
    <div class="date-picker-demo-section">
      <h2 class="section-title">{{ 'Date Picker Component Demo' | translate }}</h2>
      
      <div class="date-picker-examples">
        <app-date-picker 
          [(ngModel)]="selectedDate" 
          label="Select Date"
          placeholder="Choose a date">
        </app-date-picker>
        
        <app-date-picker 
          [(ngModel)]="selectedDateTime" 
          label="Select Date and Time"
          placeholder="Choose date and time"
          [showTime]="true">
        </app-date-picker>
        
        <app-date-picker 
          [(ngModel)]="selectedDateRange" 
          label="Select Date Range"
          placeholder="Choose date range"
          [selectionMode]="'range'">
        </app-date-picker>
      </div>
    </div>
    
    <div class="textarea-demo-section">
      <h2 class="section-title">{{ 'TextArea Component Demo' | translate }}</h2>
      
      <div class="textarea-examples">
        <app-textarea 
          [(ngModel)]="textareaValue" 
          placeholder="Enter your message here"
          label="Message"
          [rows]="4"
          [maxlength]="500">
        </app-textarea>
      </div>
    </div>
    
    <div class="dropdown-demo-section">
      <h2 class="section-title">{{ 'Dropdown Component Demo' | translate }}</h2>
      
      <div class="dropdown-examples">
        <app-dropdown 
          [(ngModel)]="selectedDropdownValue" 
          [options]="dropdownOptions"
          label="Select Option"
          placeholder="Dropdown">
        </app-dropdown>
        
        <app-dropdown 
          [(ngModel)]="selectedDropdownValue" 
          [options]="dropdownOptions"
          label="Filterable Dropdown"
          placeholder="Dropdown with filter"
          [filter]="true">
        </app-dropdown>
      </div>
      
      <h3 class="subsection-title">{{ 'Location Selection' | translate }}</h3>
      <div class="dropdown-examples">
        <app-dropdown 
          [(ngModel)]="selectedLocation.value"
          [options]="locationOptionsForDropdown"
          [label]="'Select Location' | translate"
          [placeholder]="'Choose country and city' | translate"
          [tree]="true"
          [filter]="true">
        </app-dropdown>
      </div>
    </div>
    
    <div class="typography-demo-section">
      <h2 class="section-title" style="text-align: left;">{{ 'Typography Component Demo' | translate }}</h2>
      
      <div class="typography-examples">
        <h3 class="heading-title-leafet">{{ 'Headings' | translate }}</h3>
        <app-typography variant="h3" [gutterBottom]="true" [className]="'heading-title-leafet'">Test Typography Component</app-typography>
      </div>
    </div>
    
    <div class="dialog-demo-section">
      <h2 class="section-title">{{ 'Dialog Component Demo' | translate }}</h2>
      
      <div class="dialog-examples">
        <button pButton type="button" [label]="'Basic Dialog' | translate" icon="pi pi-info-circle" 
          (click)="showBasicDialog = true" class="p-button-info"></button>
        
        <button pButton type="button" [label]="'Modal Dialog' | translate" icon="pi pi-exclamation-triangle" 
          (click)="showModalDialog = true" class="p-button-warning"></button>
        
        <button pButton type="button" [label]="'Confirmation Dialog' | translate" icon="pi pi-question-circle" 
          (click)="showConfirmDialog = true" class="p-button-danger"></button>
        
        <button pButton type="button" [label]="'Form Dialog' | translate" icon="pi pi-pencil" 
          (click)="showFormDialog = true" class="p-button-success"></button>
      </div>
    </div>
    
    <div class="map-demo-section">
      <h2 class="section-title">{{ 'Map Component Demo' | translate }} (OpenLayers)</h2>
      
      <div class="map-container">
        <app-openlayers-map
          #openlayersMapDemo
          [height]="mapHeight"
          [center]="[69.2401, 41.2995]"
          [zoom]="mapZoom"
          [drawingMode]="true"
          (mapClick)="onMapClick($event)"
          (markerClick)="onMarkerClick($event)"
          (coordinatesChange)="onCoordinatesChange($event)"
          (mapMove)="onOpenlayersMapMove($event)">
        </app-openlayers-map>
      </div>
      
      <div class="layer-controls" style="margin-top: 15px; padding: 15px; background: #f3f4f6; border-radius: 8px;">
        <h3 style="margin: 0 0 10px 0; color: #1f2937;">🗺️ Демонстрация двух тайловых слоев (OpenLayers)</h3>
        <div style="display: flex; align-items: center; gap: 20px;">
          <button pButton type="button" 
                  [label]="openlayersSatelliteVisible ? 'Скрыть спутник' : 'Показать спутник'" 
                  [icon]="openlayersSatelliteVisible ? 'pi pi-eye-slash' : 'pi pi-eye'" 
                  (click)="toggleOpenlayersSatellite()" 
                  class="p-button-sm"
                  [ngClass]="openlayersSatelliteVisible ? 'p-button-warning' : 'p-button-info'">
          </button>
          <div *ngIf="openlayersSatelliteVisible" style="display: flex; align-items: center; gap: 10px;">
            <label>Прозрачность спутника:</label>
            <input type="range" [(ngModel)]="openlayersSatelliteOpacity" min="0" max="100" step="10" 
                   (input)="updateOpenlayersSatelliteOpacity()" style="width: 150px;">
            <span>{{ openlayersSatelliteOpacity }}%</span>
          </div>
        </div>
        <p style="margin: 10px 0 0 0; color: #6b7280; font-size: 14px;">
          Базовый слой: OpenStreetMap | Второй слой: Esri Satellite
        </p>
      </div>
      
      <div class="layer-controls" style="margin-top: 15px; padding: 15px; background: #fff3cd; border-radius: 8px;">
        <h4 style="margin: 0 0 10px 0; color: #856404;">🔄 Динамическая загрузка полигонов (OpenLayers):</h4>
        <button pButton type="button" 
                [label]="openlayersDynamicPolygonsEnabled ? 'Выключить динамическую загрузку' : 'Включить динамическую загрузку'" 
                [icon]="openlayersDynamicPolygonsEnabled ? 'pi pi-stop' : 'pi pi-play'" 
                (click)="toggleOpenlayersDynamicPolygons()" 
                class="p-button-sm"
                [ngClass]="openlayersDynamicPolygonsEnabled ? 'p-button-danger' : 'p-button-warning'"
                style="margin-right: 10px;">
        </button>
        <button pButton type="button" 
                label="Очистить полигоны" 
                icon="pi pi-trash" 
                (click)="clearAllOpenlayersDynamicPolygons()" 
                class="p-button-sm p-button-secondary"
                [disabled]="openlayersPolygonsCount === 0">
        </button>
        <div style="margin-top: 10px;" *ngIf="openlayersDynamicPolygonsEnabled">
          <p style="margin: 5px 0; color: #856404;">📊 Загружено полигонов: <strong>{{ openlayersPolygonsCount }}</strong></p>
          <p style="margin: 5px 0; color: #856404;">📦 Кэшированных областей: <strong>{{ openlayersLoadedBounds.size }}</strong></p>
          <p style="margin: 5px 0; color: #666; font-size: 14px;">Двигайте карту для загрузки новых данных</p>
          <p style="margin: 5px 0; color: #ff6b6b; font-size: 12px;" *ngIf="openlayersPolygonsCount > 100">
            ⚠️ При количестве полигонов > 100 отображается только счетчик для оптимизации
            <br>💡 Приблизьте карту (zoom 15+), чтобы увидеть полигоны
          </p>
        </div>
      </div>
    </div>
    
    <div class="leaflet-map-demo-section">
      <h2 class="section-title">{{ 'Map Component Demo' | translate }} (Leaflet)</h2>
      
      <div class="map-container">
        <app-leaflet-map
          #leafletMapDemo
          [height]="'400px'"
          [center]="[environment.map.lat, environment.map.lng]"
          [zoom]="13"
          [markers]="leafletMarkers"
          [drawingMode]="false"
          (mapClick)="onLeafletMapClick($event)"
          (markerClick)="onLeafletMarkerClick($event)"
          (coordinatesChange)="onLeafletCoordinatesChange($event)"
          (mapMove)="onLeafletMapMove($event)">
        </app-leaflet-map>
      </div>
      
      <div class="map-info">
        <p class="info-text">{{ 'Click on the map to get coordinates' | translate }}</p>
        <p class="info-text" *ngIf="leafletClickedCoords">
          {{ 'Clicked coordinates' | translate }}: {{ leafletClickedCoords[0].toFixed(6) }}, {{ leafletClickedCoords[1].toFixed(6) }}
        </p>
      </div>
      
      <div class="layer-controls" style="margin-top: 15px; padding: 15px; background: #e8f5e9; border-radius: 8px;">
        <h3 style="margin: 0 0 10px 0; color: #2e7d32;">🗺️ Демонстрация двух тайловых слоев (Leaflet)</h3>
        <div style="display: flex; align-items: center; gap: 20px;">
          <button pButton type="button" 
                  [label]="leafletSatelliteVisible ? 'Скрыть спутник' : 'Показать спутник'" 
                  [icon]="leafletSatelliteVisible ? 'pi pi-eye-slash' : 'pi pi-eye'" 
                  (click)="toggleLeafletSatellite()" 
                  class="p-button-sm"
                  [ngClass]="leafletSatelliteVisible ? 'p-button-warning' : 'p-button-success'">
          </button>
          <div *ngIf="leafletSatelliteVisible" style="display: flex; align-items: center; gap: 10px;">
            <label>Прозрачность спутника:</label>
            <input type="range" [(ngModel)]="leafletSatelliteOpacity" min="0" max="100" step="10" 
                   (input)="updateLeafletSatelliteOpacity()" style="width: 150px;">
            <span>{{ leafletSatelliteOpacity }}%</span>
          </div>
        </div>
        <p style="margin: 10px 0 0 0; color: #558b2f; font-size: 14px;">
          Базовый слой: OpenStreetMap | Второй слой: Esri Satellite
        </p>
      </div>
      
      <div class="layer-controls" style="margin-top: 15px; padding: 15px; background: #e3f2fd; border-radius: 8px;">
        <h4 style="margin: 0 0 10px 0; color: #1565C0;">🔄 Динамическая загрузка полигонов (Leaflet):</h4>
        <button pButton type="button" 
                [label]="leafletDynamicPolygonsEnabled ? 'Выключить динамическую загрузку' : 'Включить динамическую загрузку'" 
                [icon]="leafletDynamicPolygonsEnabled ? 'pi pi-stop' : 'pi pi-play'" 
                (click)="toggleLeafletDynamicPolygons()" 
                class="p-button-sm"
                [ngClass]="leafletDynamicPolygonsEnabled ? 'p-button-danger' : 'p-button-info'"
                style="margin-right: 10px;">
        </button>
        <button pButton type="button" 
                label="Очистить полигоны" 
                icon="pi pi-trash" 
                (click)="clearAllLeafletDynamicPolygons()" 
                class="p-button-sm p-button-secondary"
                [disabled]="leafletPolygonsCount === 0">
        </button>
        <div style="margin-top: 10px;" *ngIf="leafletDynamicPolygonsEnabled">
          <p style="margin: 5px 0; color: #1565C0;">📊 Загружено полигонов: <strong>{{ leafletPolygonsCount }}</strong></p>
          <p style="margin: 5px 0; color: #1565C0;">📦 Кэшированных областей: <strong>{{ leafletLoadedBounds.size }}</strong></p>
          <p style="margin: 5px 0; color: #666; font-size: 14px;">Двигайте карту для загрузки новых данных</p>
          <p style="margin: 5px 0; color: #ff6b6b; font-size: 12px;" *ngIf="leafletPolygonsCount > 100">
            ⚠️ При количестве полигонов > 100 отображается только счетчик для оптимизации
            <br>💡 Приблизьте карту (zoom 15+), чтобы увидеть полигоны
          </p>
        </div>
      </div>
    </div>
    
    <div class="maplibre-gl-demo-section">
      <h2 class="section-title">{{ 'Map Component Demo' | translate }} (MapLibre GL)</h2>
      
      <div class="map-container">
        <app-maplibre-gl
          #maplibreMap
          [height]="'600px'"
          [center]="[69.2401, 41.2995]"
          [zoom]="12"
          [markers]="maplibreMarkers"
          [navigationControl]="true"
          [scaleControl]="true"
          [showWeatherControls]="true"
          (mapClick)="onMaplibreMapClick($event)"
          (markerClick)="onMaplibreMarkerClick($event)"
          (mapMove)="onMaplibreMapMove($event)"
          (mapLoad)="onMaplibreMapLoad($event)">
        </app-maplibre-gl>
      </div>
      
      <div class="map-info">
        <p class="info-text">{{ 'Click on the map to get coordinates' | translate }}</p>
        <p class="info-text" *ngIf="maplibreClickedCoords">
          {{ 'Clicked coordinates' | translate }}: {{ maplibreClickedCoords.lng.toFixed(6) }}, {{ maplibreClickedCoords.lat.toFixed(6) }}
        </p>
      </div>
      
      <div class="layer-controls">
        <h3>{{ 'Map Style' | translate }}</h3>
        <div class="button-group mb-3">
          <button pButton type="button" label="Light" icon="pi pi-sun" (click)="setMapStyle('light')" class="p-button-sm"></button>
          <button pButton type="button" label="Dark" icon="pi pi-moon" (click)="setMapStyle('dark')" class="p-button-sm p-button-secondary"></button>
          <button pButton type="button" label="Satellite" icon="pi pi-globe" (click)="setMapStyle('satellite')" class="p-button-sm p-button-info"></button>
        </div>
        
        <h3>{{ 'Layer Controls' | translate }}</h3>
        <div class="button-group">
          <button pButton type="button" 
                  label="Показать/Скрыть спутник" 
                  icon="pi pi-globe" 
                  (click)="toggleSatelliteDemo()" 
                  class="p-button-sm p-button-raised"
                  style="background: linear-gradient(45deg, #2196F3, #1976D2); border: none;">
          </button>
          <button pButton type="button" label="Add Polygon" icon="pi pi-map" (click)="addPolygonLayer()" class="p-button-sm"></button>
          <button pButton type="button" label="Add Heatmap" icon="pi pi-chart-bar" (click)="addHeatmapLayer()" class="p-button-sm p-button-success"></button>
          <button pButton type="button" label="Add Line" icon="pi pi-minus" (click)="addLineLayer()" class="p-button-sm p-button-info"></button>
          <button pButton type="button" label="Add Weather" icon="pi pi-cloud" (click)="addWeatherLayer()" class="p-button-sm p-button-warning"></button>
          <button pButton type="button" label="Clear Layers" icon="pi pi-trash" (click)="clearLayers()" class="p-button-sm p-button-danger"></button>
        </div>
        
        <div style="margin-top: 15px; padding: 15px; background: #e3f2fd; border-radius: 8px;">
          <h4 style="color: #1565C0; margin: 0 0 10px 0;">🎯 Демонстрация двух тайловых слоев:</h4>
          <p style="margin: 5px 0; color: #333;">• Базовый слой: OpenStreetMap</p>
          <p style="margin: 5px 0; color: #333;">• Второй слой: Esri Satellite (автоматически добавлен при загрузке)</p>
          <p style="margin: 5px 0; color: #666; font-size: 14px;">Откройте DevTools → Network → Images и подвигайте карту</p>
        </div>
        
        <div style="margin-top: 15px; padding: 15px; background: #f3e5f5; border-radius: 8px;">
          <h4 style="color: #7B1FA2; margin: 0 0 10px 0;">🔄 Динамическая загрузка полигонов:</h4>
          <button pButton type="button" 
                  [label]="dynamicPolygonsEnabled ? 'Выключить динамическую загрузку' : 'Включить динамическую загрузку'" 
                  [icon]="dynamicPolygonsEnabled ? 'pi pi-stop' : 'pi pi-play'" 
                  (click)="toggleDynamicPolygons()" 
                  class="p-button-sm"
                  [ngClass]="dynamicPolygonsEnabled ? 'p-button-danger' : 'p-button-success'"
                  style="margin-right: 10px;">
          </button>
          <button pButton type="button" 
                  label="Очистить полигоны" 
                  icon="pi pi-trash" 
                  (click)="clearAllDynamicPolygons()" 
                  class="p-button-sm p-button-warning"
                  [disabled]="polygonsCount === 0">
          </button>
          <div style="margin-top: 10px;" *ngIf="dynamicPolygonsEnabled">
            <p style="margin: 5px 0; color: #333;">📊 Загружено полигонов: <strong>{{ polygonsCount }}</strong></p>
            <p style="margin: 5px 0; color: #333;">📦 Кэшированных областей: <strong>{{ loadedBounds.size }}</strong></p>
            <p style="margin: 5px 0; color: #666; font-size: 14px;">Двигайте карту для загрузки новых данных</p>
          </div>
        </div>
      </div>
    </div>

    <div class="multiple-tiles-demo-section">
      <h2 class="section-title" style="background: linear-gradient(90deg, #2196F3, #1976D2); color: white; padding: 15px; border-radius: 8px; margin: 30px 0;">
        🗺️ {{ 'ДЕМОНСТРАЦИЯ: Два тайловых слоя одновременно' | translate }}
      </h2>
      
      <div class="demo-explanation" style="background: #e3f2fd; padding: 20px; border-radius: 8px; margin-bottom: 20px;">
        <h3 style="color: #1565C0; margin-bottom: 10px;">✅ Задача выполнена! Можем отображать несколько тайловых слоев одновременно</h3>
        <p style="color: #333; font-size: 16px; line-height: 1.6;">
          <strong>Что реализовано:</strong><br>
          • Базовый слой: OpenStreetMap (PNG тайлы)<br>
          • Второй слой: Спутниковые снимки Esri (PNG тайлы с прозрачностью)<br>
          • Управление прозрачностью для видимости обоих слоев<br>
          • Динамическое переключение порядка слоев
        </p>
      </div>

      <div class="map-container" style="position: relative;">
        <app-maplibre-gl
          #demoMap
          [height]="'500px'"
          [center]="[69.2401, 41.2995]"
          [zoom]="13"
          [navigationControl]="true"
          [scaleControl]="true"
          (mapLoad)="onDemoMapLoad($event)">
        </app-maplibre-gl>
        
        <!-- Индикаторы активных слоев -->
        <div class="layer-indicators" style="position: absolute; top: 10px; left: 10px; background: white; padding: 15px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.2); z-index: 1000;">
          <h4 style="margin: 0 0 10px 0; color: #1565C0;">Активные тайловые слои:</h4>
          <div style="display: flex; flex-direction: column; gap: 8px;">
            <div style="display: flex; align-items: center;">
              <div style="width: 20px; height: 20px; background: #4CAF50; border-radius: 50%; margin-right: 8px;"></div>
              <span><strong>Слой 1:</strong> OpenStreetMap (базовый)</span>
            </div>
            <div style="display: flex; align-items: center;">
              <div style="width: 20px; height: 20px; background: #2196F3; border-radius: 50%; margin-right: 8px;"></div>
              <span><strong>Слой 2:</strong> Esri Satellite ({{ demoSatelliteOpacity }}% прозрачность)</span>
            </div>
          </div>
        </div>
        
        <!-- Контролы управления -->
        <div class="demo-controls" style="position: absolute; top: 10px; right: 10px; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.2); z-index: 1000; width: 300px;">
          <h4 style="margin: 0 0 15px 0; color: #1565C0;">Управление слоями:</h4>
          
          <div style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 5px; font-weight: bold;">Прозрачность спутникового слоя:</label>
            <input type="range" [(ngModel)]="demoSatelliteOpacity" min="0" max="100" step="10" 
                   (input)="updateDemoSatelliteOpacity()" style="width: 100%;">
            <div style="text-align: center; margin-top: 5px;">{{ demoSatelliteOpacity }}%</div>
          </div>
          
          
        </div>
      </div>
      
      <!-- Технические детали -->
      <div class="technical-details" style="background: #f5f5f5; padding: 20px; border-radius: 8px; margin-top: 20px;">
        <h4 style="color: #333; margin-bottom: 15px;">Как это работает:</h4>
        <pre style="background: #263238; color: #aed581; padding: 15px; border-radius: 4px; overflow-x: auto;">
</pre>
      </div>
      
      <div class="verification-info" style="background: #e8f5e9; padding: 20px; border-radius: 8px; margin-top: 20px;">
        <h4 style="color: #2e7d32; margin-bottom: 10px;">Как проверить:</h4>
        <ol style="margin: 0; padding-left: 20px;">
          <li>Откройте DevTools (F12) → Network → Images</li>
          <li>Подвигайте карту - увидите загрузку тайлов от двух источников</li>
          <li>Меняйте прозрачность - оба слоя будут видны одновременно</li>
          <li>Используйте кнопки управления для демонстрации возможностей</li>
        </ol>
      </div>
    </div>
  </div>
  
  <app-dialog [(visible)]="showBasicDialog" header="Basic Dialog" width="50vw" [modal]="false" [closable]="true">
    <p>{{ 'This is a basic dialog with simple content. It can be moved around and closed with the X button or by clicking outside.' | translate }}</p>
    <p>{{ 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.' | translate }}</p>
  </app-dialog>
  
  <!-- Modal Dialog -->
  <app-dialog [(visible)]="showModalDialog" header="Modal Dialog" width="50vw" [modal]="true" [draggable]="false" [closable]="true" [showFooter]="true">
    <p class="m-0" style="display: flex; align-items: center;">
      <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: var(--yellow-500); margin-right: 1rem;"></i>
      {{ 'This is a modal dialog. It blocks interaction with the rest of the page until closed.' | translate }}
    </p>
    <ng-template #footer>
      <button pButton type="button" [label]="'Cancel' | translate"  class="p-button-text p-button-cancel-btn " (click)="showModalDialog = false"></button>
      <button pButton type="button" [label]="'Proceed' | translate"   class="p-button-warning" (click)="showModalDialog = false"></button>
    </ng-template>
  </app-dialog>
  
  <!-- Confirmation Dialog -->
  <app-dialog [(visible)]="showConfirmDialog" header="Confirm Action" width="450px" [modal]="true" [closable]="true" [showFooter]="true">
    <div style="display: flex; align-items: center;">
      <i class="pi pi-question-circle" style="font-size: 3rem; color: var(--red-500); margin-right: 1rem;"></i>
      <span>{{ 'Are you sure you want to proceed with this action? This cannot be undone.' | translate }}</span>
    </div>
    <ng-template #footer>
      <button pButton type="button" [label]="'No' | translate"   class="p-button-text p-button-cancel-btn" (click)="showConfirmDialog = false"></button>
      <button pButton type="button" [label]="'Yes' | translate" class="p-button-danger" (click)="handleConfirm()"></button>
    </ng-template>
  </app-dialog>
  
  <!-- Form Dialog -->
  <app-dialog [(visible)]="showFormDialog" header="Upload Images" width="500px" [modal]="true" [closable]="true" [showFooter]="true">
    <div class="dialog-form-content">
      <app-input 
        [(ngModel)]="dialogFormData.name"
        [label]="'Name' | translate"
        [placeholder]="'Enter name' | translate">
      </app-input>
      
      <app-input 
        [(ngModel)]="dialogFormData.email"
        [label]="'Email' | translate"
        type="email"
        [placeholder]="'Enter email' | translate">
      </app-input>
      
      <app-dropdown 
        [options]="roleOptions" 
        [(ngModel)]="dialogFormData.role" 
        [label]="'Role' | translate"
        [placeholder]="'Select a role' | translate">
      </app-dropdown>
      
      <div class="form-field">
        <label for="description">{{ 'Description' | translate }}</label>
        <app-textarea 
          [(ngModel)]="dialogFormData.description" 
          [rows]="3" 
          [placeholder]="'Enter description' | translate">
        </app-textarea>
      </div>
    </div>
    <ng-template #footer>
      <button pButton type="button" [label]="'Cancel' | translate"  class="p-button-text p-button-cancel-btn" (click)="showFormDialog = false"></button>
      <button pButton type="button" [label]="'Save' | translate"  class="p-button-success" (click)="handleFormSave()"></button>
    </ng-template>
  </app-dialog>
</div>

